import React from 'react';
import Dialog from 'material-ui/Dialog';
import FileUploadCallDetailsActions from 'actions/files/FileUploadCallDetailsActions';
import 'styles/call-card/sync-crm/CallCRMRecord.styl';
import CallSyncCRMPaperButton from './CallSyncCRMPaperButton';
import CloseIcon from 'images/common/CloseModal.svg';

const customContentStyle = {
  width: '40%',
  maxWidth: '350px',
};

/**
 * CallSyncCRMRecordDialog renders the crm-record-dialog for all the call-cards that have their crm data populated
 */
class CallSyncCRMRecordDialog extends React.Component {
  constructor(props) {
    super(props);
    this.onTouchTapCloseButton = this.onTouchTapCloseButton.bind(this);
    this.onTouchTapCRMPaperButton = this.onTouchTapCRMPaperButton.bind(this);
  }

  /** Close the CallSyncCRMRecordDialog by informing FileUploadCallDetailsStore to set its related state variable to
   *  null so that this component will be closed
   **/
  onTouchTapCloseButton() {
    FileUploadCallDetailsActions.hideCRMRecordDialog();
  }

  /**
   * Either open a new page that points to this.props.crmLink or show the CRM sync dialog
   * @param {string} imageName Name of the image in the crm-paper-button
   */
  onTouchTapCRMPaperButton(imageName) {
    if (imageName === 'view-in-salesforce' && this.props.crmLink) {
      window.open(this.props.crmLink, '_blank');
    } else if (imageName === 'resync-salesforce') {
      this.onTouchTapCloseButton();
      setImmediate(() => {
        FileUploadCallDetailsActions.showCallSyncCRM(this.props.fileUploadId);
      });
    }
  }

  /**
   * Render a dialog that contains two buttons, view-in-salesforce / resync-with-salesforce
   */
  render() {
    return (
      <Dialog
        open={this.props.open}
        autoScrollBodyContent={true}
        title="CRM Record"
        bodyStyle={{overflow: 'visible'}}
        contentStyle={customContentStyle}>
        <img
          alt="dialog close"
          className="dialog-close-button"
          src={CloseIcon}
          onClick={this.onTouchTapCloseButton}
        />
        <div className="dialog-content">
          <CallSyncCRMPaperButton
            outerDivClassName="left-element"
            imageName="view-in-salesforce"
            firstLine="View in"
            onTouchTapCRMPaperButton={this.onTouchTapCRMPaperButton}
          />
          <CallSyncCRMPaperButton
            outerDivClassName="right-element"
            imageName="resync-salesforce"
            firstLine="Resync with"
            onTouchTapCRMPaperButton={this.onTouchTapCRMPaperButton}
          />
        </div>
      </Dialog>
    );
  }
}

export default CallSyncCRMRecordDialog;
